

<!-- <hr class="my-4">

<div class="d-flex mb-3">
	<fa-icon [icon]="['fas', 'exclamation-triangle']" class="mr-2 text-orange"></fa-icon>
	<div class="font-weight-bold text-green-dark">Special Cancellation Policy</div>
</div> -->

<div class="{{className}}">
	<div class="mb-4 text-green-dark" *ngIf="cancelationType == 0">
		<span class="font-weight-bold">This trip is non-cancellable</span>
	</div>
	<div class="mb-4 text-green-dark" *ngIf="cancelationType == 2">
		<span class="font-weight-bold">This trip has an exception which is outside of our standard cancellation policy: </span>
		<span [innerHTML]="product.cancellationPolicy"></span>
	</div>

	<div class="mb-4 text-green-dark" *ngIf="cancelationType == 3">
		<span class="font-weight-bold">This trip is outside our standard cancellation policy and will become non-refundable at {{product?.minimumCancelationInDays}} days from the date of the tour.  </span>
		<span [innerHTML]="product.cancellationPolicy"></span>
	</div>

	<div class="mb-4 text-green-dark" *ngIf="cancelationType == 4">
		<span class="font-weight-bold">This trip is outside our standard cancellation policy and will become non-refundable at {{product?.minimumCancelationInDays}} days from the date of the tour. In addition: </span>
		<span [innerHTML]="product.cancellationPolicy"></span>
	</div>

</div>
